module.exports = __webpack_public_path__ + "img/rs_multigreenL-design.f682216.png";